import { SsnQuestionModel } from 'app/shared/models/ssn-question.model';
import { Component, OnInit, forwardRef, Input, } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormGroupDirective, NgForm } from '@angular/forms';
import { FormControl } from '@angular/forms/src/model';
import { ErrorStateMatcher } from '@angular/material';

export const DATE_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SsnMaskedComponent),
  multi: true
};
@Component({
  selector: 'online-app-ssn-masked',
  templateUrl: './ssn-masked.component.html',
  styleUrls: ['./ssn-masked.component.scss'],
  providers: [DATE_VALUE_ACCESSOR]
})
export class SsnMaskedComponent implements ControlValueAccessor, OnInit {
 
  @Input() fieldName: string;
  
  private propagateChange = (_: any) => { };
  public onTouched: any = () => { /*Empty*/ }  
  protected ssnThreeMask = [/\d/, /\d/, /\d/];
  protected ssnTwoMask = [/\d/, /\d/];
  protected ssnFourMask = [/\d/, /\d/,/\d/, /\d/];

  protected ssnErrorMatcher=new SsnErrorStateMatcher(this.getSSNValue.bind(this));

  private _ssnThreeNumbers:number;
  private _ssnTwoNumbers:number;
  private _ssnFourNumbers:number;

  get ssnThreeNumbers(){
    return this._ssnThreeNumbers;
  }

  set ssnThreeNumbers(val){
    this._ssnThreeNumbers=val;
    this.propagateChange(this.getSSNValue());
  }

  get ssnTwoNumbers(){
    return this._ssnTwoNumbers;
  }

  set ssnTwoNumbers(val){
    this._ssnTwoNumbers=val;
    this.propagateChange(this.getSSNValue());
  }

  get ssnFourNumbers(){
    return this._ssnFourNumbers;
  }

  set ssnFourNumbers(val){
    this._ssnFourNumbers=val;
    this.propagateChange(this.getSSNValue());
  }


  
  writeValue(obj: any): void {
    if(obj){
      let ssn=obj.replace(/-/gi,'').toString();
      this._ssnThreeNumbers=ssn.substr(0,3)
      this._ssnTwoNumbers=ssn.substr(3,2)
      this._ssnFourNumbers=ssn.substr(5,4)
      this.propagateChange(this.getSSNValue())
    }else{
      this.propagateChange(null);
    }  
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  protected onFocus(e){   
    this.onTouched();
  }

  constructor() { }

  ngOnInit() {  

  }

  private getSSNValue(){
    return `${this._ssnThreeNumbers || ''}-${this._ssnTwoNumbers || ''}-${this._ssnFourNumbers || ''}`.replace(/_/gi,'');
  }

  protected keytab(event, maxLength){ 
    let nextInput;
    
    if (maxLength == 3 && event.target.value.length == 3){  
      nextInput = document.getElementById("TwoNumbers");
      if (nextInput !== null)  
          nextInput.focus();
      }
    if (maxLength == 2 && event.target.value.length == 2){
      nextInput = document.getElementById("FourNumbers");
      if (nextInput !== null)     
          nextInput.focus();
    }    
  }
}




class SsnErrorStateMatcher implements ErrorStateMatcher {

  constructor(private calcFieldLength:()=>string){
  }

  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    if(!control.value){
      return control.touched || control.dirty;
    }
    else{
      return this.calcFieldLength().length !== 11;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/ssn-masked/ssn-masked.component.ts